// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__tQ2az","blockMsg":"Message_blockMsg__o0lzt","avatar":"Message_avatar__Kjx6V","avatarBg":"Message_avatarBg__kuiuo","nameAuthor":"Message_nameAuthor__q7Pdg"};